document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.main-nav');
  if (menuBtn && nav) menuBtn.addEventListener('click', () => {
    const open = menuBtn.getAttribute('aria-expanded') === 'true';
    menuBtn.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('is-open');
  });

  const key = 'dhd-favorite-plans';
  const getFavorites = () => {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch(e) { return []; }
  };
  const saveFavorites = (items) => localStorage.setItem(key, JSON.stringify([...new Set(items)]));
  const updateFavoriteUi = () => {
    const favorites = getFavorites();
    document.querySelectorAll('[data-favorites-count]').forEach(el => el.textContent = favorites.length ? `(${favorites.length})` : '');
    document.querySelectorAll('[data-favorite-button]').forEach(btn => {
      const active = favorites.includes(btn.dataset.productHandle);
      btn.classList.toggle('is-favorite', active);
      if (btn.classList.contains('favorite-inline')) btn.textContent = active ? '♥ Saved' : '♡ Save';
      else btn.textContent = active ? '♥' : '♡';
    });
  };
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-favorite-button]');
    if (!btn) return;
    event.preventDefault(); event.stopPropagation();
    const handle = btn.dataset.productHandle;
    let items = getFavorites();
    items = items.includes(handle) ? items.filter(x => x !== handle) : [...items, handle];
    saveFavorites(items); updateFavoriteUi();
  });
  updateFavoriteUi();

  const lightbox = document.querySelector('[data-image-lightbox]');
  const lightboxImg = document.querySelector('[data-lightbox-image]');
  document.querySelectorAll('[data-gallery-item]').forEach(item => item.addEventListener('click', () => {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = item.dataset.imageSrc;
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }));
  const closeLightbox = () => { if(lightbox){ lightbox.hidden = true; document.body.style.overflow = ''; } };
  document.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', e => { if(e.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', e => { if(e.key === 'Escape') closeLightbox(); });

  const favoritesGrid = document.querySelector('[data-favorites-grid]');
  if (favoritesGrid) renderFavorites(favoritesGrid, getFavorites(), key, updateFavoriteUi);
});

async function renderFavorites(grid, handles, key, updateFavoriteUi){
  const empty = document.querySelector('[data-favorites-empty]');
  if (!handles.length){ empty.hidden = false; return; }
  const cards = [];
  for (const handle of handles){
    try{
      const response = await fetch(`/products/${handle}.js`);
      if(!response.ok) continue;
      const product = await response.json();
      cards.push(`<article class="favorite-result" data-favorite-row="${handle}"><a href="${product.url}"><img src="${product.featured_image || ''}" alt=""></a><div><h3><a href="${product.url}">${product.title}</a></h3><p>${Shopify.formatMoney ? Shopify.formatMoney(product.price) : '$' + (product.price/100).toFixed(2)}</p><button class="favorite-remove" type="button" data-remove-favorite="${handle}">Remove</button></div></article>`);
    }catch(e){}
  }
  grid.innerHTML = cards.join('');
  if(!cards.length){ empty.hidden = false; }
  grid.addEventListener('click', e => {
    const btn = e.target.closest('[data-remove-favorite]'); if(!btn) return;
    const handle = btn.dataset.removeFavorite;
    const next = handles.filter(x => x !== handle);
    localStorage.setItem(key, JSON.stringify(next));
    btn.closest('[data-favorite-row]')?.remove();
    if(!grid.children.length) empty.hidden = false;
    updateFavoriteUi();
  });
}
